import { Delete, Edit } from "@mui/icons-material";
import { Box, Card, CardContent, Divider, Grid, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { GENDER_OPTIONS, NO_RECORDS_FOUND } from "../../../../../../utils/constants";
import { AppUtils } from "../../../../../../utils/appUtils";
import { AppMisc } from "../../../../../../misc/appMisc";
import { getDataFromServer } from "../../../../../../utils/apiUtils";
import { API_URL } from "../../../../../../api/api";


const StanpaiAamaThathaShishuSewaVivaran = ({ page, totalSize, ...props }) => {
  const [mainRegisterData, setMainRegisterData] = useState([]);
  const tableRef = useRef();
  const [cardData, setCardData] = useState([]);
  const id = AppUtils.getUrlParam("id");

  useEffect(() => {
    if (props.tableData !== null) {
      if (page) {
        setMainRegisterData(prev => {
          return [...prev, ...props.tableData]
        })
      } else {
        tableRef.current.scrollTo(0, 0)
        setMainRegisterData(props.tableData)
      }
    }
  }, [props.tableData])

  const fetchData = () => {
    props.handleChangePage(page + 1);
    props.getTableData(true)
  }

  const getCardData = async () => {
    let url = API_URL.stanpaiAama + "/" + id
    let response = await getDataFromServer(url)
    if (response) {
      setCardData(response)
    }
  }

  useEffect(() => {
    getCardData()
  }, [])

  return (
    <>
      <Card>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="subtitle1">सेवाग्राहीको सामान्य विवरण</Typography>
              <Divider />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              दर्ता मिति:{AppMisc.getDateLabelFromMillisecond(cardData?.dartaaMiti)}
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              नाम:{cardData?.patientFirstName}
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              थर:{cardData?.patientLastName}
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              उमेर:{cardData?.age && AppUtils.replaceWithNepaliDigit(cardData.age) + "वर्ष"}
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              लिङ्ग:{cardData?.gender && AppMisc.findLabelFromValue(GENDER_OPTIONS, cardData.gender)}
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              जिल्ला:{cardData?.district && AppMisc.getDistrictName(cardData.district)}
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              नगर/गाउँपालिका:{cardData?.palikaName}
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              वडा नं:{cardData?.wardNumber && AppUtils.replaceWithNepaliDigit(cardData.wardNumber)}
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              टोल:{cardData?.gaunOrTole}
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              सम्पर्क नं.:{cardData?.phoneNumber && AppUtils.replaceWithNepaliDigit(cardData?.phoneNumber)}
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      <InfiniteScroll
        dataLength={mainRegisterData?.length}
        next={fetchData}
        hasMore={mainRegisterData?.length !== totalSize}
        loader={<p style={{ textAlign: 'center' }} className="print-none">Loading....</p>}
        scrollableTarget="mul-dartaa-register"
      >
        <TableContainer classes={{ root: "fixed-head-table-container" }} ref={tableRef} >
          <Table classes={{ root: "table-bordered normal-spacing" }} size="small" aria-label="Mul Dartaa Register">
            <TableHead classes={{ root: "align-center fixed-header header-sm" }}>
              <TableRow>
                <TableCell>क्र.सं.</TableCell>
                <TableCell>दर्ता मिति</TableCell>
                <TableCell>सुत्केरी अवधि</TableCell>
                <TableCell>समस्या (भएमा मात्र)</TableCell>
                <TableCell>बितरित औषधि</TableCell>
                <TableCell>फाईल संख्या</TableCell>
                <TableCell>स्तन्यको अवस्था</TableCell>
                <TableCell>परिक्षण/सल्लाह</TableCell>
                <TableCell>कैफियत</TableCell>
                <TableCell>सम्पादन</TableCell>
              </TableRow>
            </TableHead>
            <TableBody classes={{ root: "align-center" }}>
              {mainRegisterData?.length > 0 ? (
                mainRegisterData?.map((row, index) => (
                  <TableRow key={row.id}>
                    <TableCell>{AppUtils.replaceWithNepaliDigit(index + 1)}</TableCell>
                    <TableCell>{AppMisc.getDateLabelFromMillisecond(row?.dartaaMiti)}</TableCell>
                    <TableCell>{row?.sutkeriDuration || "-"}</TableCell>
                    <TableCell>{row?.distributedMedicine || "-"}</TableCell>
                    <TableCell>{row?.treatmentDetails || "-"}</TableCell>
                    <TableCell>{row.fileNumber || "-"}</TableCell>
                    <TableCell>{row.breastfeedingStatus || "-"}</TableCell>
                    <TableCell>{row.examinationAdvice || "-"}</TableCell>
                    <TableCell>{row.remarks || "-"}</TableCell>
                    <TableCell>
                      <Box display="flex" justifyContent="space-between" alignItems="center">
                        <IconButton aria-label="edit" onClick={() => props.onEditRow(row.id)}>
                          <Edit fontSize="small" />
                        </IconButton>
                        <Tooltip title="रेकर्ड हटाउन यहा क्लिक गर्नुहोस" placement="top" arrow>
                          <IconButton onClick={() => props.deleteRow(row.id)}>
                            <Delete fontSize="small" color="secondary" />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan="41" size="medium">{NO_RECORDS_FOUND}</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </InfiniteScroll>
    </>
  )
}

export default StanpaiAamaThathaShishuSewaVivaran

